import React, { useState, useEffect } from 'react';
import { styled, SvgIcon } from '@teko/ui';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Button = styled.div((props) => `
  position: relative;
  padding: 0 1rem;
  text-align: center;
  height: ${props.height}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-sizing: content-box;
  border: 1px solid  var(--button-background-color, ${props.isOpen || props.count ? props.theme.brand.primary : props.theme.colors.gray300});
  color: ${props.count ? props.theme.brand.primary : ""};
  cursor: pointer;
  border-radius: 4px;
 
  ${props.isOpen && `
    z-index: 10;
    border-bottom: transparent;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}
  `);
const Wrapper = styled.div`
  display: inline-block;
`;
const Text = styled.span`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1;
  overflow: hidden;
`;
const StyledIcon = styled(SvgIcon)`
  position: relative;
  top: 1px;
  left: 2px;
`;
const DropdownContent = styled.div((props) => `
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: 1px solid ${props.theme.brand.primary};
  position: absolute;
  left: 0;
  right: 0;
  margin-top: -1px;
  z-index: 5;
  background: #fff;
`);
const Badge = styled.span(({ theme }) => `
    font-size: 0.625rem;
    background: ${theme == null ? void 0 : theme.brand.primary};
    border-radius: 50%;
    width: 16px;
    line-height: 16px;
    color: #fff;
    height: 16px;
    text-align: center;
    margin: 0 5px;
  `);
const JDDropdown = (_a) => {
  var _b = _a, {
    text,
    children,
    height = 34,
    count = 0
  } = _b, props = __objRest(_b, [
    "text",
    "children",
    "height",
    "count"
  ]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [endDelay, setEndDelay] = useState(false);
  useEffect(() => {
    if (dropdownOpen) {
      setTimeout(() => {
        setEndDelay(true);
      }, 200);
    } else {
      setEndDelay(false);
    }
  }, [dropdownOpen, endDelay]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    onMouseEnter: () => setDropdownOpen(true),
    onMouseLeave: () => setDropdownOpen(false)
  }, props), /* @__PURE__ */ React.createElement(Button, {
    className: "dropdown-button",
    isOpen: dropdownOpen && endDelay,
    height,
    count
  }, /* @__PURE__ */ React.createElement(Text, null, text), count > 0 && /* @__PURE__ */ React.createElement(Badge, null, count), /* @__PURE__ */ React.createElement(StyledIcon, {
    name: dropdownOpen && endDelay ? "chevron-up" : "chevron-down",
    size: 12
  })), dropdownOpen && endDelay && /* @__PURE__ */ React.createElement(DropdownContent, {
    className: "dropdown-content",
    isOpen: dropdownOpen,
    height,
    onClick: () => setDropdownOpen(false)
  }, children));
};

export { JDDropdown };
